import React, { useState } from 'react';
import { CheckCircle, Award, Sparkles, Home, Zap, Droplet, Banknote, Building, Shield, Package, Flame } from 'lucide-react';
import developmentProjectsData from '../data/development_projects.json';

function DevelopmentProjects() {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    // Icon mapping for different project types
  const getProjectIcon = (projectName) => {
    if (projectName.includes('கழிப்பறை') || projectName.includes('தூய்மை')) return Home;
    if (projectName.includes('மின்சாரம்')) return Zap;
    if (projectName.includes('குடிநீர்') || projectName.includes('குழாய்')) return Droplet;
    if (projectName.includes('விவசாயி') || projectName.includes('₹6000')) return Banknote;
    if (projectName.includes('வங்கி')) return Building;
    if (projectName.includes('காப்பீடு') || projectName.includes('சிகிச்சை')) return Shield;
    if (projectName.includes('அரிசி') || projectName.includes('தானியம்')) return Package;
    if (projectName.includes('கேஸ்')) return Flame;
    return CheckCircle;
  };

  // Color schemes for variety
  const colorSchemes = [
    { bg: 'from-orange-500 to-orange-600', light: 'bg-orange-50', text: 'text-orange-600', border: 'border-orange-200' },
    { bg: 'from-blue-500 to-blue-600', light: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-200' },
    { bg: 'from-green-500 to-green-600', light: 'bg-green-50', text: 'text-green-600', border: 'border-green-200' },
    { bg: 'from-purple-500 to-purple-600', light: 'bg-purple-50', text: 'text-purple-600', border: 'border-purple-200' },
    { bg: 'from-pink-500 to-pink-600', light: 'bg-pink-50', text: 'text-pink-600', border: 'border-pink-200' },
    { bg: 'from-indigo-500 to-indigo-600', light: 'bg-indigo-50', text: 'text-indigo-600', border: 'border-indigo-200' },
    { bg: 'from-red-500 to-red-600', light: 'bg-red-50', text: 'text-red-600', border: 'border-red-200' },
    { bg: 'from-teal-500 to-teal-600', light: 'bg-teal-50', text: 'text-teal-600', border: 'border-teal-200' }
  ];

  return (
    <div>
      {/* Page Header */}
      <div className="relative bg-gradient-to-r from-orange-600 via-orange-500 to-orange-400 text-white py-20 overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-10"></div>
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-72 h-72 bg-white opacity-5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-white opacity-5 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex items-center justify-center mb-6">
              <Award className="w-16 h-16 animate-pulse" />
            </div>
            <h1 className="text-5xl md:text-6xl font-extrabold mb-4">
              வளர்ச்சித் திட்டங்கள்
            </h1>
            <div className="flex items-center justify-center gap-2 text-orange-100">
              <Sparkles className="w-5 h-5" />
              <span className="text-lg">மக்கள் நலனுக்கான நமது ஒனஂறியதஂதிலஂ செயலஂபடுதஂதிய மகஂகளஂ நலதஂ திடஂடஙஂகளஂ</span>
              <Sparkles className="w-5 h-5" />
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Stats Banner */}
        {/* <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl shadow-2xl p-8 mb-12 text-white">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div>
              <TrendingUp className="w-10 h-10 mx-auto mb-2" />
              <div className="text-4xl font-bold mb-1">{developmentProjectsData.length}</div>
              <div className="text-orange-100">முக்கிய திட்டங்கள்</div>
            </div>
            <div>
              <Heart className="w-10 h-10 mx-auto mb-2" />
              <div className="text-4xl font-bold mb-1">கோடிக்கணக்கான</div>
              <div className="text-orange-100">பயனாளிகள்</div>
            </div>
            <div>
              <CheckCircle className="w-10 h-10 mx-auto mb-2" />
              <div className="text-4xl font-bold mb-1">100%</div>
              <div className="text-orange-100">செயல்படுத்தப்பட்டவை</div>
            </div>
          </div>
        </div> */}

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {developmentProjectsData.map((project, index) => {
            const Icon = getProjectIcon(project.project_name);
            const colors = colorSchemes[index % colorSchemes.length];
            const isHovered = hoveredIndex === index;

            return (
              <div
                key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                className={`group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden ${
                  isHovered ? 'transform scale-105' : ''
                }`}
              >
                {/* Decorative Background */}
                <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${colors.bg} opacity-10 rounded-bl-full transition-all duration-300 ${
                  isHovered ? 'w-48 h-48' : ''
                }`}></div>

                <div className="relative px-6 lg:px-6 sm:px-2">
                  {/* Number Badge */}
                  <div className="absolute top-4 right-4">
                    <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${colors.bg} text-white flex items-center justify-center font-bold text-lg shadow-lg`}>
                      {index + 1}
                    </div>
                  </div>

                  {/* Icon */}
                  <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${colors.bg} flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-8 h-8 text-white" />
                  </div>

                  {/* Project Name */}
                  <h3 className="text-xl font-bold text-gray-800 mb-3 leading-relaxed pr-16">
                    {project.project_name}
                  </h3>

                  {/* Decorative Line */}
                  {/* <div className={`w-full h-1 bg-gradient-to-r ${colors.bg} rounded-full mb-4 transition-all duration-300 ${
                    isHovered ? 'scale-x-100' : 'scale-x-50'
                  } origin-left`}></div> */}

                  {/* Status Badge */}
                  {/* <div className="flex items-center gap-2">
                    <div className={`flex items-center gap-2 ${colors.light} ${colors.text} px-4 py-2 rounded-full`}>
                      <CheckCircle className="w-4 h-4" />
                      <span className="font-semibold text-sm">செயல்படுத்தப்பட்டது</span>
                    </div>
                  </div> */}
                </div>

                {/* Hover Effect Border */}
                <div className={`absolute inset-0 border-2 ${colors.border} rounded-2xl transition-opacity duration-300 ${
                  isHovered ? 'opacity-100' : 'opacity-0'
                }`}></div>
              </div>
            );
          })}
        </div>

        {/* Bottom Info Card */}
        {/* <div className="mt-12 bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-8 border-2 border-green-200">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center shadow-xl">
                <Sparkles className="w-10 h-10 text-white" />
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-bold text-gray-800 mb-2">
                மக்கள் நலன் சார்ந்த வளர்ச்சி
              </h3>
              <p className="text-gray-600 leading-relaxed">
                இந்தியாவின் வளர்ச்சிக்காகவும், மக்களின் வாழ்க்கைத் தரத்தை உயர்த்துவதற்காகவும் செயல்படுத்தப்பட்ட முக்கிய திட்டங்கள். 
                ஒவ்வொரு குடும்பமும் இந்த திட்டங்களின் பயனாளியாக உள்ளனர்.
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );

}

export default DevelopmentProjects;